<template>
  <div class="collective">
    <div class="backdrop"></div>
    <div class="content">
      <div class="content-title">
        <slot name="title"></slot>
        <!-- <a-button type="danger" @click="close()" size="small" icon="close"></a-button> -->
      </div>
      <div class="content-body">
        <slot name="content"></slot>
      </div>
      <div class="content-footer">
        <slot name="resume"></slot>
        <slot name="action"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    close: {
      type: Function,
    },
    datasource: {},
  },
  name: "collective-modal",
};
</script>

<style lang="less" scoped>
.collective {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 100vh;
  width: 100vw;

  .backdrop {
    background-color: fade(black, 30%);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .content {
    background-color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1001;
    height: 600px;
    width: 1000px;
    display: flex;
    flex-direction: column;
    overflow: auto;

    &-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      padding: 0 @padding;
      border-bottom: 1px solid darken(white, 10);
      font-weight: bold;
    }

    &-body {
      flex: 1;
      padding: @padding;
      overflow: auto;
    }

    &-footer{
      border-top: 1px solid darken(white, 10);
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 @padding;
    }
  }
}
</style>